import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  Add,
  CalendarToday,
  Settings,
} from "@mui/icons-material";
import { PageHeader } from "@/components/common/PageHeader";
import { PageHub } from "@/components/common/PageHub";

export function ScheduleSettings() {
  const navigate = useNavigate();

  const cards = useMemo(
    () => [
      {
        title: "Gerenciar agendas",
        icon: <Settings fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Visualize e gerencie todas as funcionalidades das agendas",
        onClick: () => navigate("/schedule"),
      },
      {
        title: "Criar agenda",
        icon: <Add fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Crie e configure novas agendas",
        onClick: () => navigate("/newschedule"),
      },
    ],
    [navigate],
  );

  return (
    <PageHub
      header={<PageHeader title="Agendas" icon={CalendarToday} centered />}
      sections={[
        {
          cards,
        },
      ]}
    />
  );
}
